import { render, staticRenderFns } from "./empty_state_without_any_issues.vue.js?vue&type=template&id=28222b62&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./empty_state_without_any_issues.vue?vue&type=template&id=28222b62&scoped=true"
import script from "./empty_state_without_any_issues.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./empty_state_without_any_issues.vue?vue&type=script&lang=js"
export * from "./empty_state_without_any_issues.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./empty_state_without_any_issues.vue?vue&type=script&lang=js"
import style0 from "./empty_state_without_any_issues.vue.css?vue&type=style&index=0&id=28222b62&prod&scoped=true&lang=css!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./empty_state_without_any_issues.vue?vue&type=style&index=0&id=28222b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28222b62",
  null
  
)

export default component.exports